<lm-form
    *ngIf="formSpec && m_messageRuleView"
    [formUrlInfo]="formUrlInfo"
    [formSpec]="formSpec"
    [initDataView]="m_messageRuleView"
    (formRendered)="onFormRendered($event)"
></lm-form>
